<template>
    <div>
        <el-card :body-style="{'padding-bottom': '0'}" shadow="never">
            <el-form v-if="form" :inline="true" :size="form.size" @submit.native.prevent="query">
                <el-form-item v-if="form.tools">
                    <template v-for="(tool, i) in form.tools">
                        <el-tooltip v-if="tool.icon" :key="i" :content="tool.label" :disabled="!tool.label" :hide-after="1000">
                            <el-button :icon="tool.icon" @click="tool.click"></el-button>
                        </el-tooltip>
                        <el-button v-else :key="i" @click="tool.click">{{tool.label}}</el-button>
                    </template>
                </el-form-item>
                <template v-if="formConfigs.length > 0">
                    <template v-if="formConfigs.length === 1 && formConfigs[0].type === 'input'">
                        <el-form-item>
                            <el-input :placeholder="formConfigs[0].label" v-model="formConfigs[0].value" clearable @clear="query" style="width: 360px">
                                <el-button slot="append" icon="el-icon-search" native-type="submit"></el-button>
                            </el-input>
                        </el-form-item>
                    </template>
                    <template v-else>
                        <template v-if="formConfigs.length > 1">
                            <form-item :config="formConfigs[0]"></form-item>
                            <form-item :config="formConfigs[1]"></form-item>

                            <template v-if="formConfigs.length > 2">
                                <el-tooltip :content="$t('更多')" :hide-after="1000">
                                    <el-button @click="formDrawer = true" icon="el-icon-more"></el-button>
                                </el-tooltip>
                            </template>
                        </template>
                        <template v-else>
                            <form-item :config="config" v-for="(config, i) in formConfigs" :key="i"></form-item>
                        </template>

                        <el-tooltip :content="$t('查询')" :hide-after="1000">
                            <el-button type="primary" native-type="submit" icon="el-icon-search"></el-button>
                        </el-tooltip>
                        <el-tooltip :content="$t('重置')" :hide-after="1000">
                            <el-button @click="clear" icon="el-icon-refresh-left"></el-button>
                        </el-tooltip>
                    </template>
                </template>
            </el-form>
        </el-card>
        <el-drawer ref="drawer" :visible.sync="formDrawer" :with-header="false" size="40%" v-if="form && formConfigs.length > 2">
            <div class="el-drawer__content">
                <el-scrollbar>
                    <el-form :inline="false" label-width="100px" label-position="left">
                        <form-item :config="config" v-for="(config, i) in formConfigs" :key="i"></form-item>
                    </el-form>
                </el-scrollbar>
            </div>
            <div class="el-drawer__footer">
                <el-button @click="clear">{{$t('重置')}}</el-button>
                <el-button type="primary" @click="query">{{$t('查询')}}</el-button>
            </div>
        </el-drawer>
        <el-card shadow="never">
            <el-table :data="rows" :highlight-current-row="table.radio" :default-sort="sort"
                      @selection-change="selectionChange" @current-change="selectionChange" @sort-change="sortChange">
                <el-table-column type="selection" width="55" v-if="table.checkbox"></el-table-column>
                <el-table-column type="expand" v-if="table.expand">
                    <template #default="{row}">
                        <slot name="expand" v-bind:row="row"></slot>
                    </template>
                </el-table-column>
                <el-table-column :key="i" v-for="(column, i) in table.columns"
                                 :prop="column['name']" :label="column.label" :width="column.width"
                                 :sortable="column.sortable ? 'custom' : false"
                                 :align="column['name'] === 'tools' ? 'center' : 'left'">
                    <template #default="{row, column}">
                        <slot name="tools" v-bind:row="row" v-if="column.property === 'tools'">
                            <el-tooltip :content="$t('删除')" placement="top">
                                <el-button type="text" icon="el-icon-delete" size="small" @click="toDel(row)"></el-button>
                            </el-tooltip>
                        </slot>
                        <slot v-bind:row="row" v-bind:property="column.property" v-else>
                            {{getColumnVal(row, column.property)}}
                        </slot>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="m-t"
                    @size-change="load"
                    @current-change="load"
                    :page-sizes="[10, 15, 30, 50]"
                    :current-page.sync="page"
                    :page-size.sync="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </el-card>
    </div>
</template>

<i18n locale="en" lang="yaml">
    "是否进行删除操作？": "This will permanently delete the data. Continue?"
</i18n>

<script>
    import FormItem from '@/components/FormItem'

    export default {
        components: {
            FormItem
        },
        props: ["form", "table"],
        data() {
            return {
                formDrawer: false,
                total: 0,
                rows: [],
                page: 1,
                limit: 10,
                orders: this.table.orders
            }
        },
        mounted() {
            // 设置默认排序
            this.table.columns.forEach(column => {
                if (column.name === "createTime") {
                    this.orders = {"createTime": "desc"};
                    return false;
                }
            });

            this.query();
        },
        computed: {
            formConfigs() {
                let configs = [];
                if (this.form && this.form.configs) {
                    this.form.configs.forEach(config => {
                        if (config.type === "hidden") {
                            return true;
                        }

                        configs.push(config);
                    });
                }
                return configs;
            },
            sort() {
                if (this.orders) {
                    let prop = Object.keys(this.orders)[0];
                    return {prop: prop, order: this.orders[prop] + "ending"};
                } else {
                    return {};
                }
            }
        },
        methods: {
            getColumnVal(row, prop) {
                let val = row[prop];
                if (val === null || val === undefined) {
                    return "";
                }
                if (val['text']) {
                    return val['text'];
                } else {
                    return val;
                }
            },
            sortChange(data) {
                this.orders = {[data['prop']]: data['order'] === "descending" ? "desc" : "asc"};
                this.load();
            },
            selectionChange(selections) {
                this.$emit("selection-change", selections);
            },
            getParams() {
                let params = {};
                if (this.form && this.form.configs) {
                    this.form.configs.forEach(config => {
                        let op = config.op ? config.op : "equal";
                        let val = config.value;
                        // 空值，空数组，空数值(0)
                        if (val === "" || val === null || val === undefined || (val !== 0 && val.length === 0)) {
                            return;
                        }

                        params[config.name] = val;
                        if (!params["ops"]) {
                            params["ops"] = {};
                        }
                        params["ops"][config.name] = op;
                    });
                }

                params['limit'] = this.limit;
                params['offset'] = (this.page - 1) * this.limit;

                if (this.orders) {
                    params['orders'] = this.orders;
                }
                return params;
            },
            query() {
                this.formDrawer = false;
                this.page = 1;
                this.load();
            },
            load() {
                let params = this.getParams();

                const vue = this;
                if (this.table.methods && this.table.methods.query) {
                    this.table.methods.query(params).then(response => {
                        vue.total = response.total;
                        vue.rows = response.rows;
                    });
                } else {
                    this.$axios.post(this.table.urlPrefix + '/paging', params).then(response => {
                        vue.total = response.data.total;
                        vue.rows = response.data.rows;
                    });
                }
            },
            clear() {
                if (this.form && this.form.configs) {
                    this.form.configs.forEach(config => {
                        if (config.type !== "hidden") {
                            config.value = null;
                        }
                    });
                }
                this.query();
            },
            toDel(row) {
                this.$confirm(this.$t("是否进行删除操作？"), this.$t("提示"), {
                    confirmButtonText: this.$t("确定"),
                    cancelButtonText: this.$t("取消"),
                    type: 'warning'
                }).then(() => {
                    this.$axios.get(this.table.urlPrefix + '/remove/' + row.id).then(response => {
                        if (response['code'] === 0) {
                            this.$message.success(this.$t("删除成功！"));
                            this.load();
                        } else {
                            this.$message.error(response['msg']);
                        }
                    })
                });
            },
        }
    }
</script>